<mat-dialog-content style="width:480px;">
  <h4>{{ messages[type] }}</h4>
  <h4 style="color: red">{{ data.message }}</h4>
</mat-dialog-content>
@if (type === 'error') {
  <mat-dialog-actions align="right">
    <button color="warn" mat-button mat-dialog-close>Noted</button>
  </mat-dialog-actions>
}
